(function () {
  function getStep(wrap, track) {
    const firstItem = wrap.querySelector('li.grid-item');
    if (!firstItem) return Math.round(track.clientWidth * 0.9);

    const ul = wrap.querySelector('.scroller-inner > ul');
    const gap = ul ? parseFloat(getComputedStyle(ul).gap || '0') : 0;
    return Math.round(firstItem.getBoundingClientRect().width + gap);
  }

  function updateButtons(wrap, track) {
    const prev = wrap.querySelector('[data-reco-prev]');
    const next = wrap.querySelector('[data-reco-next]');
    if (!prev || !next) return;

    const max = track.scrollWidth - track.clientWidth;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= (max - 2);
  }

  function initWrap(wrap) {
    const track = wrap.querySelector('[data-reco-track]');
    if (!track) return;

    // Bind once per track (Shopify re-renders this)
    if (track.dataset.recoInit === '1') return;
    track.dataset.recoInit = '1';

    const prev = wrap.querySelector('[data-reco-prev]');
    const next = wrap.querySelector('[data-reco-next]');

    prev && prev.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(wrap, track), behavior: 'smooth' });
    });

    next && next.addEventListener('click', () => {
      track.scrollBy({ left: getStep(wrap, track), behavior: 'smooth' });
    });

    const onUpdate = () => updateButtons(wrap, track);
    track.addEventListener('scroll', onUpdate, { passive: true });
    window.addEventListener('resize', onUpdate);

    setTimeout(onUpdate, 50);
    setTimeout(onUpdate, 300);
  }

  function initAll() {
    document.querySelectorAll('[data-reco-wrap]').forEach(initWrap);
  }

  initAll();

  const mo = new MutationObserver(() => requestAnimationFrame(initAll));
  mo.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', initAll);
})();
